import type { UseFormRegisterReturn } from 'react-hook-form';

/** Solo dígitos (p. ej. CUIT). Opcionalmente trunca a `maxLength`. */
export function filterDigitsOnly(value: string, maxLength?: number): string {
  let out = value.replace(/\D/g, '');
  if (maxLength != null && out.length > maxLength) {
    out = out.slice(0, maxLength);
  }
  return out;
}

/** Teléfono: dígitos y opcionalmente un "+" solo al inicio. */
export function filterPhoneInput(value: string): string {
  const leadingPlus = value.trimStart().startsWith('+');
  const digits = value.replace(/\D/g, '');
  return leadingPlus ? `+${digits}` : digits;
}

/** Aplica un filtro al registrar un input con react-hook-form. */
export function withInputFilter(
  registration: UseFormRegisterReturn,
  filter: (value: string) => string,
): UseFormRegisterReturn {
  const { onChange, ...rest } = registration;
  return {
    ...rest,
    onChange: (event) => {
      const el = event.target as HTMLInputElement;
      const filtered = filter(el.value);
      if (filtered !== el.value) {
        el.value = filtered;
      }
      return onChange(event);
    },
  };
}
